// This file is part of Invenio-RDM-Records
// Copyright (C) 2020-2023 CERN.
// Copyright (C) 2020-2022 Northwestern University.
//
// Invenio-RDM-Records is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

export const DRAFT_FETCHED = "DRAFT_FETCHED";
export const DRAFT_HAS_VALIDATION_ERRORS = "DRAFT_HAS_VALIDATION_ERRORS";

// Draft save
export const DRAFT_SAVE_STARTED = "DRAFT_SAVE_STARTED";
export const DRAFT_SAVE_SUCCEEDED = "DRAFT_SAVE_SUCCEEDED";
export const DRAFT_SAVE_FAILED = "DRAFT_SAVE_FAILED";

// Draft publish
export const DRAFT_PUBLISH_STARTED = "DRAFT_PUBLISH_STARTED";
export const DRAFT_PUBLISH_FAILED = "DRAFT_PUBLISH_FAILED";
export const DRAFT_PUBLISH_FAILED_WITH_VALIDATION_ERRORS =
  "DRAFT_PUBLISH_FAILED_WITH_VALIDATION_ERRORS";

// Draft preview
export const DRAFT_PREVIEW_STARTED = "DRAFT_PREVIEW_STARTED";
export const DRAFT_PREVIEW_FAILED = "DRAFT_PREVIEW_FAILED";

// Draft delete
export const DRAFT_DELETE_STARTED = "DRAFT_DELETE_STARTED";
export const DRAFT_DELETE_FAILED = "DRAFT_DELETE_FAILED";

// Draft submit review
export const DRAFT_SUBMIT_REVIEW_STARTED = "DRAFT_SUBMIT_REVIEW_STARTED";
export const DRAFT_SUBMIT_REVIEW_FAILED = "DRAFT_SUBMIT_REVIEW_FAILED";
export const DRAFT_SUBMIT_REVIEW_FAILED_WITH_VALIDATION_ERRORS =
  "DRAFT_SUBMIT_REVIEW_FAILED_WITH_VALIDATION_ERRORS";

// Draft reserve PID
export const RESERVE_PID_STARTED = "RESERVE_PID_STARTED";
export const RESERVE_PID_SUCCEEDED = "RESERVE_PID_SUCCEEDED";
export const RESERVE_PID_FAILED = "RESERVE_PID_FAILED";

// Draft discard PID
export const DISCARD_PID_STARTED = "DISCARD_PID_STARTED";
export const DISCARD_PID_SUCCEEDED = "DISCARD_PID_SUCCEEDED";
export const DISCARD_PID_FAILED = "DISCARD_PID_FAILED";

// Files
export const FILE_UPLOAD_ADDED = "FILE_UPLOAD_ADDED";
export const FILE_UPLOAD_IN_PROGRESS = "FILE_UPLOAD_IN_PROGRESS";
export const FILE_UPLOAD_FINISHED = "FILE_UPLOAD_FINISHED";
export const FILE_UPLOAD_FAILED = "FILE_UPLOAD_FAILED";
export const FILE_UPLOAD_SAVE_DRAFT_FAILED = "FILE_UPLOAD_SAVE_DRAFT_FAILED";

export const FILE_IMPORT_STARTED = "FILE_IMPORT_STARTED";
export const FILE_IMPORT_SUCCESS = "FILE_IMPORT_SUCCESS";
export const FILE_IMPORT_FAILED = "FILE_IMPORT_FAILED";

export const FILE_DELETED_SUCCESS = "FILE_DELETED_SUCCESS";
export const FILE_DELETE_FAILED = "FILE_DELETE_FAILED";

export const FILE_UPLOAD_SET_CANCEL_FUNCTION = "FILE_UPLOAD_SET_CANCEL_FUNCTION";
export const FILE_UPLOAD_CANCELLED = "FILE_UPLOAD_CANCELLED";

// Community
export const SET_COMMUNITY = "SET_COMMUNITY";
